import React from 'react';

import { colorWithAlpha } from '../../../common/color';

const HEADER_HEIGHT_PX = 25;

export default function TimelineHoverMarkerLines({
  hoverState,
  zoom,
  timeToPixels,
}) {
  if (!hoverState?.markers?.length) {
    return null;
  }

  return (
    <>
      {hoverState.markers.map((marker) => (
        <div
          key={`${hoverState.taskId}-${marker.key}`}
          className={`timeline-hover-marker-line timeline-hover-marker-line-${marker.type}`}
          style={{
            left: `${timeToPixels(marker.minutes, zoom)}px`,
            top: `${HEADER_HEIGHT_PX}px`,
            '--timeline-hover-marker-color': colorWithAlpha(
              hoverState.color,
              0.85,
              'rgba(255, 255, 255, 0.82)'
            ),
            '--timeline-hover-marker-glow': colorWithAlpha(
              hoverState.color,
              0.22,
              'rgba(255, 255, 255, 0.18)'
            ),
          }}
        />
      ))}
    </>
  );
}
